import styled from "@emotion/styled";
import { tokens } from "../../../design-system/tokens";
import { TooltipProps } from "./Tooltip";

export const TooltipWrapper = styled.div<{ width?: "full" | "auto" }>`
  position: relative;
  display: flex;
  cursor: default;
  width: ${({ width }) => (width === "auto" ? "auto" : "100%")};

  &:hover .tooltip:not(:empty) {
    opacity: 1;
    visibility: visible;
  }
`;

const getHorizontalAlignment = (align: TooltipProps["align"]) => {
  if (align === "start") {
    return `
      left: 0;
      transform: none;
    `;
  }

  if (align === "end") {
    return `
      right: 0;
      transform: none;
    `;
  }

  if (align === "safeEnd") {
    return `
    left: 50%;
    transform: translateX(calc(-50% - 105px));
`;
  }

  return `
    left: 50%;
    transform: translateX(-50%);
  `;
};

export const TooltipText = styled.div<{
  position: TooltipProps["position"];
  align: TooltipProps["align"];
}>`
  position: absolute;
  background-color: ${tokens.colors.tooltip};
  color: ${tokens.colors.basics[0]};
  padding: ${tokens.spacing.xs} ${tokens.spacing.sm};
  border-radius: ${tokens.borderRadius.sm};
  text-align: left;
  font-size: ${tokens.typography.fontSize.xs};
  font-family: ${tokens.typography.fontFamily.primary};
  white-space: normal;
  max-width: 310px;
  width: max-content;
  opacity: 0;
  visibility: hidden;
  transition: ${tokens.transitions.fast};
  z-index: ${tokens.zIndex.tooltip};
  box-shadow: ${tokens.shadows.md};

  ${({ position, align }) => {
    switch (position) {
      case "top":
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: ${tokens.spacing.sm};
        `;
      case "left":
        return `
          top: 50%;
          right: 100%;
          transform: translateY(-50%);
          margin-right: ${tokens.spacing.sm};
        `;
      case "right":
        return `
          top: 50%;
          left: 100%;
          transform: translateY(-50%);
          margin-left: ${tokens.spacing.sm};
        `;
      case "inputInfo":
        return `
          top: 20%;
          right: 100%;
          margin-top: ${tokens.spacing.sm};
          width: 250px;
          white-space: normal;
          word-break: break-word;
          text-align: left;
          `;

      default: // bottom
        return `
          top: 100%;
          ${getHorizontalAlignment(align)}
          margin-top: ${tokens.spacing.sm};
        `;
    }
  }}
`;
